// extracted by mini-css-extract-plugin
module.exports = {"livescore_wrap":"style_livescore_wrap__1Sv8k","livescore_empty":"style_livescore_empty__GYG62"};